module.exports = __webpack_public_path__ + "img/icon-filter.28f1bca5.svg";